import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { routing, appRoutingProviders } from './app.routing';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContentComponent } from './components/content/content.component';

import { ModalComponent } from './directives/modal.component';
import { ModalService } from './services/modal.service';
import { Ng2CarouselamosModule } from 'ng2-carouselamos';
import { ContentService} from './services/content.service';
import { SafePipe } from './safe.pipe';
import { QRCodeModule } from 'angular2-qrcode';
import { Error505Component } from './components/error505/error505.component';
import { MainComponent } from './components/main/main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Error400Component } from './components/error400/error400.component';
import { ImageViewerModule} from 'ngx-image-viewer';
import { ContactComponent } from './components/contact/contact.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContentComponent,
    ModalComponent,
    SafePipe,
    Error505Component,
    MainComponent,
    Error400Component,
    ContactComponent,
  ],
  imports: [
    BrowserModule,
    Ng2CarouselamosModule,
    HttpModule,
    HttpClientModule,
    QRCodeModule,
    routing,
    ReactiveFormsModule,
    ImageViewerModule.forRoot()
  ],
  providers: [
    ModalService,
    ContentService,
    appRoutingProviders,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts